


//  Initialization
//  ---------------

    window.CNN = window.CNN || {};

    var $ = require('jquery');

            require.context("../media/", true, /^\.\/.*\.*/);
            require('../styles/cnn-interactive-delegate-roll-call.scss');
            require('../js/sharebar.js');

//  Import Modules
//  ---------------

    import { StateResultsTable  } from '../js/mod/roll-call-mod--results-table';
    import { ResultsCard        } from '../js/mod/roll-call-mod--results-card';
    import { PeriodicMap        } from '../js/mod/roll-call-mod--periodic-map';

    // import * as statesConfig from '../data/states-config.json';

//  Project Variables
//  ---------------

    var interactive = $('#cnn_delegate_roll_call');

    //

//  CNN_Delegate_Roll_Call [Class]
//  @description:   Main class for running the interactive.
//  ---------------

    class CNN_Delegate_Roll_Call
    {
        constructor()
        {
            this.interval = null;
            this.showFullResults = interactive.hasClass('show-full-results');
            // this.feed = "http://data.cnn.com/jsonp/interactive/2016/conventions-roll-call/rnc/rnc2016.json";
            this.feed = "http://data.cnn.com/jsonp/interactive/2016/conventions-roll-call/dnc/dnc2016.json";
            this.initalized = false;
            this.data = null;

            this.delegatesRemaining = 0;

            this.resultsCards = [];

            this.init();
        }

        init()
        {
            this.loadFeed();
        }

        // ----------------
        //  Build
        // ----------------

        build()
        {
            this.createElements();
            this.buildResultCards();
            this.buildPeriodicMap();
            this.buildStateTable();
            
            this.initalized = true;

            this.startInteractive();
        }

        createElements()
        {
            this.resultsContainer = interactive.find('.cnn-delegate-roll-call--results-container');
            this.periodicMapElement = interactive.find('.cnn-delegate-roll-call--periodic-map');
            this.resultsTableElement = interactive.find('.cnn-delegate-roll-call--results-table');

            this.delegatesTotalCounter = interactive.find('.cnn-delegate-roll-call--delegate-count__total');
            this.delegatesRemainingCounter = interactive.find('.cnn-delegate-roll-call--delegate-count__remaining');
            
            this.toggleFullResultsBtn = interactive.find('.cnn-delegate-roll-call__toggle-btn');
            this.toggleFullResultsBtn.on('click', $.proxy(this.toggleClass, this));

            this.overlay = $('.cnn-delegate-roll-call--overlay');
        }

        buildResultCards()
        {
            if(this.resultsContainer && this.resultsContainer.length > 0)
            {
                $.each(this.data['candidates'], $.proxy(function(id, val)
                {
                    if(parseInt(val['id']) !== 99999)
                    {
                        var newResultsCard = $("<div id='resultCard" + id + "' class='cnn-delegate-roll-call--results-card" + (id > 1 ? " full-results" : "") + (id > 2 ? " snapshot col-xs-third col-sm-third col-md-third col-lg-third col-xl-third" : " col-xs-4 col-sm-8 col-md-10 col-lg-12 col-xl-12") + "'>");
                            this.resultsCards.push(new ResultsCard( newResultsCard, { td : this.data['td_k'], nom : this.data['d_nom'] } ));
                            this.resultsContainer.append( newResultsCard );
                    }
                }, this));
            }
        }

        buildPeriodicMap()
        {
            if(this.periodicMapElement && this.periodicMapElement.length > 0)
            {
                this.periodicMap = new PeriodicMap(this.periodicMapElement);
            }
        }

        buildStateTable()
        {
            if(this.resultsTableElement && this.resultsTableElement.length > 0)
            {
                this.resultsTable = new StateResultsTable(this.resultsTableElement);
            }
        }

        startInteractive()
        {
            $('[data-cnn-sharebar]').children().on('click', onShareButtonClick);

            this.update();
            
            if(!this.isComplete())
            {
                this.interval = setInterval( $.proxy(function()
                {
                    if(!this.isComplete())
                    {
                        this.loadFeed()
                    }
                    else
                    {
                        clearInterval(this.interval);
                    }
                }, this), 60000);
            }
        }

        // ----------------
        //  Data
        // ----------------

        processData(p_data)
        {
            //  Order candidates by top delegate count
                
                p_data['nationraces'] = p_data['nationraces'].sort(this.sortCandidatesByDelegates);

            //  If no delegates have yet been awarded, then 
            //  sort Trump and Cruz to the top of the nationraces array.

                // if(parseInt(p_data['nationraces'][0]['rd']) === 0)
                // {
                //     var trumpId = $.grep(p_data['candidates'], function(e){ return e['lname'].toLowerCase() === "trump"; })[0]['id'];
                //     var trumpLocation = p_data['nationraces'].indexOf( $.grep(p_data['nationraces'], function(e){ return parseInt(e['id']) === trumpId; })[0] );
                //         p_data['nationraces'].unshift( p_data['nationraces'].splice(trumpLocation, 1)[0] );
                // }

                // if(parseInt(p_data['nationraces'][1]['rd']) === 0)
                // {
                //     var cruzId = $.grep(p_data['candidates'], function(e){ return e['lname'].toLowerCase() === "cruz"; })[0]['id'];
                //     var cruzLocation = p_data['nationraces'].indexOf( $.grep(p_data['nationraces'], function(e){ return parseInt(e['id']) === cruzId; })[0] );
                //         p_data['nationraces'].splice( 1, 0 , p_data['nationraces'].splice(cruzLocation, 1)[0] );
                // }

            //  Create object for "Other" to tally results for all other 
            //  candidates other than the leader.

                var otherResultObject = this.generateOtherCandidateDataObject();

            //  Reset the delegatesRemaining value to the total number of delegates.
            
                this.delegatesRemaining = p_data['td_k'];

            //  Run through all candidates to calculate the remaining number of delegates, as
            //  well as tally results for the "Other" object.
                
                $.each(p_data['nationraces'], $.proxy(function(id, val)
                {
                    this.delegatesRemaining -= parseInt(val['td']);
                    if(id !== 0) otherResultObject['rd'] += parseInt(val['td']);
                }, this));

            //  Push in the "Other" object
                p_data['candidates'].push( this.generateOtherCandidate() );
                p_data['nationraces'].push(otherResultObject);

            return p_data;
        }

        getCandidateById(p_id, p_src)
        {
            var p_id = parseInt(p_id),
                p_src = p_src || this.data,
                r_candidate = null;

            if(!isNaN(p_id))
            {
                $.each(p_src['candidates'], function(id, val)
                {
                    if(parseInt(val['id']) === p_id) r_candidate = val;
                });
            }

            return r_candidate;
        }

        sortCandidatesByName(a, b)
        {
            return a['lname'] > b['lname'];
        }

        sortCandidatesByDelegates(a, b)
        {
            return (parseInt(a['rd']) < parseInt(b['rd'])) ? 1 : (parseInt(a['rd']) > parseInt(b['rd'])) ? -1 : 0;
        }

        generateOtherCandidateDataObject()
        {
            return {
                "id" : 99999,
                "rd" : 0,
            };
        }

        generateOtherCandidate()
        {
            return {
                "id" : 99999,
                "fname" : "",
                "lname" : "Other",
                "nominee" : false
            }
        }

        calculateOtherCandidateResults(obj, candidateArray, omitId)
        {
            omitId = omitId != null ? omitId : -9999;

            $.each(candidateArray, function(i, v)
            {
                if(parseInt(v['id']) !== omitId)
                {
                    obj['rd'] += parseInt(v['rd']);
                }
            });

            return obj;
        }

        // ----------------
        //  Update
        // ----------------

        update()
        {
            this.updateDelegates();
            this.updateResultsCards();
            this.updateStateData();
        }

        updateDelegates()
        {
            this.delegatesTotalCounter.html( this.data['td_k_s'] );
            this.delegatesRemainingCounter.html( formatNumber(this.delegatesRemaining) );
        }

        updateResultsCards()
        {
            if(this.showFullResults)
            {
                $.each(this.resultsCards, $.proxy(function(id, val)
                {
                    val.update( this.data['nationraces'][id] );
                }, this));
            }
            else
            {
                this.resultsCards[0].update(this.data['nationraces'][0]);
                this.resultsCards[1].update(this.data['nationraces'][ this.data['nationraces'].length - 1 ]);
            }
        }

        updateStateData()
        {
            //  Update Table with top two candidates, or "Other" if showAllResults is false.
            //  ------------

                var tableCandidates =
                [
                    this.data['nationraces'][0],
                    (this.showFullResults
                        ? this.data['nationraces'][1]
                        : this.data['nationraces'][this.data['nationraces'].length - 1])
                ];

                if(this.resultsTable) this.resultsTable.data = tableCandidates;

                if(this.periodicMap)
                {
                    if(this.periodicMap.legend.length === 0)
                    {
                        this.periodicMap.addCandidateToLegend( this.getCandidateById(this.data['nationraces'][0]['id']) );
                        this.periodicMap.addCandidateToLegend( this.showFullResults
                                                                    ? this.getCandidateById(this.data['nationraces'][1]['id'])
                                                                    : this.generateOtherCandidate() );
                    }
                }
            
            //  Update both the PeriodicMap and State Table.

                $.each(this.data['states'], $.proxy(function(id, val)
                {
                    //  Sort state by state candidate data by most delegates awarded.

                        val['candidates'] = val['candidates'].sort( this.sortCandidatesByDelegates );

                    //  Update Tiles
                    //  ------------

                        if(this.periodicMap !== null)
                        {
                            if(parseInt(val['candidates'][0]['rd']) !== 0)
                            {
                                var tile = this.periodicMap.getTileById(val['code']);
                                if(tile) tile.data = val;

                                this.periodicMap.addCandidateToLegend( this.getCandidateById(val['candidates'][0]['id']) );
                            }
                        }

                    //  Update Table Items
                    //  ------------------

                        if(this.resultsTable !== null)
                        {
                            var item = this.resultsTable.getItemById(val['code']);

                            if(item)
                            {
                                var firstCandidate = $.grep(val['candidates'], function(e){ return parseInt(e['id']) === parseInt(tableCandidates[0]['id']); })[0];
                                var secondCandidate = (this.showFullResults)
                                    ? $.grep(val['candidates'], function(e){ return parseInt(e['id']) === parseInt(tableCandidates[1]['id']); })[0]
                                    : this.calculateOtherCandidateResults(this.generateOtherCandidateDataObject(), val['candidates'], parseInt(tableCandidates[0]['id']));

                                item.data = [ firstCandidate, secondCandidate ];
                            }
                        }

                }, this));
        }

        // ----------------
        //  Methods
        // ----------------

        showAllResults( p_showResults )
        {
            switch(p_showResults)
            {
                case undefined : case null :
                    interactive.toggleClass('show-full-results');
                    break;

                case true :
                    if(!interactive.hasClass('show-full-results')) interactive.addClass('show-full-results');
                    break;

                case false : default :
                    if(interactive.hasClass('show-full-results')) interactive.removeClass('show-full-results');
                    break;
            }

            interactive.removeClass('show-full-results__active');
            
            this.showFullResults = interactive.hasClass('show-full-results');
            this.update();
        }

        toggleClass(e)
        {
            var target = $(e.currentTarget),
                toggleClass = target.data('action');

            interactive.toggleClass(toggleClass);
        }

        isModule()
        {
            return interactive.hasClass('hp-module');
        }

        isComplete()
        {
            return interactive.hasClass('complete');
        }

        loadFeed()
        {
            $.ajax(this.feed, {
                dataType : "jsonp",
                jsonpCallback : "jsonpCallback"
            })
            .done($.proxy(this.onLoadFeedSuccess, this))
            .error($.proxy(this.onLoadFeedError, this));
        }

        // ----------------
        //  Events
        // ----------------

        onLoadFeedSuccess(p_data)
        {
            // console.log("Data loaded successfully!");
            
            this.data = this.processData(p_data);

            if(this.initalized === false)
            {
                this.build();
            }
            else
            {
                this.update();
            }
        }

        onLoadFeedError(err)
        {
            console.error("Error loading feed");
            console.error(err)
        }
    }

    function formatNumber(p_num)
    {
        return p_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    function shareCustomPost(post, service, popwidth, popheight, popscroll)
    {
        post = post || "CNN";
        service = service || "facebook";
        popscroll = popscroll = 'no';
        popheight = popheight = 420;
        popwidth = popwidth = 550;

        cnnshare.share.popup(post, service, popwidth, popheight, popscroll);
        cnnshare.share.track({
                "type": "click",
                "site": service
        });
    }

    function onShareButtonClick(e)
    {
        //  Extract the share data from the parent of the button pressed,
        //  and set those values to be passed along to the CNNShare module.

        var btn = $(e.currentTarget),
           shareData = btn.parent().data(),
           service = btn.data('service'),

           title = shareData.headline || "default name",
           facebookDescription = shareData.facebookDescription || "default facebookDescription",
           twitterDescription = shareData.twitterDescription || "default twitterDescription",
           img_url = shareData.image || "default image url",
           bitlyUrl = shareData.bitlyurl || "default url",
           url = shareData.url || "default url",

           popscroll = 'no',
           popheight = 420,
           popwidth = 550,

           post = "";

        switch(service)
        {
           case 'twitter' :
               post =  'http://twitter.com/intent/tweet?url=' + encodeURIComponent(bitlyUrl);
               post += '&text=' + encodeURIComponent(twitterDescription);
               post += '&related=cnnmultimedia&via=cnn';
               break;

           case 'facebook' : 
               post =  "http://www.facebook.com/dialog/feed?display=popup&app_id=80401312489";
               post += "&link=" + encodeURIComponent(url);
               post += "&name=" + encodeURIComponent(title);
               post += "&description=" + encodeURIComponent(facebookDescription);
               post += "&redirect_uri=" + encodeURIComponent("http://www.cnn.com/");
               post += "&picture=" + encodeURIComponent(img_url);
               break;

           case 'email' : 
           default :
               post = 'mailto:?to=&subject=On%20CNN:%20'+encodeURIComponent(title)+'&body='+encodeURIComponent(title)+'%0D%0A%0D%0A'+encodeURIComponent(url);
               popheight = 150;
               popwidth = 150;
               break;
        }

        shareCustomPost(post, service, popwidth, popheight, popscroll);
    }

    CNN.interactive = CNN.interactive || {};
    CNN.interactive.roll_call = CNN.interactive.roll_call || new CNN_Delegate_Roll_Call();



/** WEBPACK FOOTER **
 ** ./src/js/cnn-interactive-delegate-roll-call.js
 **/